import firebase from '../firebase';
import { v4 as uuidv4 } from 'uuid';

export const addCategory = obj => {
	return async dispatch => {
		dispatch({ type: 'ADD_CATEGORY_REQUEST' });
		let data;
		let image = obj.imageURL;
		let filename = image.name;
		let storageRef = await firebase
			.storage()
			.ref('medicine/' + filename)
			.put(image);

		let url = await storageRef.ref.getDownloadURL();
		data = {
			...obj,
			imageURL: url,
		};

		await firebase
			.firestore()
			.collection('category')
			.add(data)
			.then(res => {
				dispatch({ type: 'ADD_CATEGORY_SUCCESS' });
				return 'response';
			})
			.catch(err => {
				dispatch({ type: 'ADD_CATEGORY_SUCCESS' });
				alert(err.message);
			});
	};
};

export const getCategories = () => {
	return async dispatch => {
		await firebase
			.firestore()
			.collection('category')
			.onSnapshot(query => {
				let allProducts = [];
				query.forEach(doc => {
					allProducts.push({ id: doc.id, ...doc.data() });
				});
				dispatch({ type: 'GET_ALL_CATEGORIES', payload: allProducts });
				return allProducts;
			});
	};
};

// export const getSingleProduct = id => {
// 	return async dispatch => {
// 		await firebase
// 			.firestore()
// 			.collection('products')
// 			.doc(id)
// 			.get()
// 			.then(res => {
// 				dispatch({ type: 'GET_SINGLE_PRODUCTS', payload: res.data() });
// 				return res.data();
// 			});
// 	};
// };

export const updateCategory = (id, obj) => async dispatch => {
	await firebase
		.firestore()
		.collection('category')
		.doc(id)
		.update(obj)
		.then(res => {
			dispatch({ type: 'UPDATE_CATEGORY' });
			return 'response';
		});
};
export const deleteCategory = id => async dispatch => {
	await firebase
		.firestore()
		.collection('category')
		.doc(id)
		.delete()
		.then(res => {
			dispatch({ type: 'DELETE_CATEGORY' });
			return 'response';
		});
};
